import request from '@/router/axios'
import env from '@/config/env'

/**
 * 列表
 */
export const queryPage = (data) => {
  return request({
    url: env.ferryUrl + '/openApi/line/page',
    method: 'POST',
    data
  })
}

/**
 * 调价
 */
export const adjust = (data) => {
  return request({
    url: env.ferryUrl + '/openApi/line/adjust',
    method: 'POST',
    data
  })
}

/**
 * 关闭
 */
export const closes = (ids) => {
  return request({
    url: env.ferryUrl + `/openApi/line/close/${ids}`,
    method: 'GET'
  })
}

/**
 * 开启
 */
export const opens = (data) => {
  return request({
    url: env.ferryUrl + '/openApi/line/open',
    method: 'POST',
    data
  })
}

/**
 * 日志
 */
export const log = (data) => {
  return request({
    url: env.ferryUrl + '/openApi/line/log',
    method: 'POST',
    data
  })
}
